require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./mission-de-la-vpfi-1-1-2-0.json") })
        }
      }, "path---mission-de-la-vpfi-1-1-2-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---mission-de-la-vpfi-1-1-2-0!./.cache/json/mission-de-la-vpfi-1-1-2-0.json
// module id = 497
// module chunks = 231608221292675